import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class AssistService {

  constructor(private http: HttpClient) { }

  getAssistList(queryParams?): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.GET_ASSIST_LIST, {params})
      .pipe(
        catchError(errorHandl)
      );
  }


  getAllAssists(): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.GET_ASSIST_LIST, {})
      .pipe(
        catchError(errorHandl)
      );
  }


  getBuckAttendee() {
    // const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.GET_BUCKATTENDEE_LIST)
      .pipe(
        catchError(errorHandl)
      );
  }
  getBuckAttendeebyId(buckId) {
    console.log(buckId);
    // const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.GET_BUCKATTENDEE_LIST + '/' + `${buckId}`)
      .pipe(
        catchError(errorHandl)
      );
  }

  addBuckAttendee(payload, buckId) {
    console.log('reached in service', payload, buckId);
    if (buckId) {
      return this.http.put<any>(urls.BASE_URL + urls.GET_BUCKATTENDEE_LIST + '/' + buckId, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.GET_BUCKATTENDEE_LIST, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getAssistDashboard(queryParams) {
    return this.http.post<any>(urls.BASE_URL + urls.GET_BUCKATTENDEE_DASHBOARD , queryParams)
      .pipe(
        catchError(errorHandl)
      );
  }

 
}
